import { render, staticRenderFns } from "./other-info.vue?vue&type=template&id=ce8ee430"
import script from "./other-info.vue?vue&type=script&lang=js"
export * from "./other-info.vue?vue&type=script&lang=js"
import style0 from "./other-info.vue?vue&type=style&index=0&id=ce8ee430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports